import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { func, string, bool } from "prop-types";
import { withRouter } from "react-router-dom";
import { Button, Modal, ModalHeader, ModalFooter } from "reactstrap";
import { getMessage } from "CONFIG/i18n";
import "./Popup.less";

// Constants
import { USER_ROLES } from "UTILS/Constants";
import { CONFIG } from "UTILS/Constants";
import { wsocket } from "WEBSOCKET/wsocket";
import { isIE, isMobile } from 'react-device-detect';

// Selectors
import {selectUserRole} from "../../Whiteboard/selectors";
import modalScrollBar from "../../ModalScrollBar/ModalScrollBar";

class ErrorPopup extends React.Component {
  static propTypes = {
    handleYesClick: func,
    handleNoClick: func,
    message: string,
    isDoubleButton: bool,
    isPresenter: bool
  };

  componentDidMount() {
    if (!wsocket.io) return;
  }

  handleYesClick = () => {
    this.props.handleYesClick();
  };
  handleNoClick = () => {
    this.props.handleNoClick();
  };
  handleOkClick = () => {
    if (this.props.organiser == this.props.uniqueId || this.props.isOrganizer) {
      // If token is not set to null user is redirected to create session page and not login page
      this.props.cleanUp && this.props.cleanUp();
      if(this.props.userRole == USER_ROLES.SUPER_ADMIN)
        this.props.history.push(CONFIG.path.superAdminLogin);
      else if(this.props.userRole == USER_ROLES.ADMIN)
        this.props.history.push(CONFIG.path.adminLogin);
      else 
        this.props.history.push(CONFIG.path.login);
    } else {
      this.props.history.push(CONFIG.path.sessionEnded);
    }
  };
  renderButtons = () => {
    if (!this.props.isDoubleButton) {
      return (
        <>
          <Button
            onClick={
              this.props.handleOkClick
                ? this.props.handleOkClick
                : this.handleOkClick
            }
            className="buttons width-25 btn-accept customBtn"
          >
            {getMessage("OK")}
          </Button>
        </>
      );
    } else if (this.props.isDoubleButton) {
      return (
        <>
          <Button
            color="#FF8E01"
            onClick={this.handleYesClick}
            className="buttons width-25 btn-accept customBtn"
          >
            {this.props.isPermissionPopup ? getMessage("ACCEPT") : getMessage("YES")}
          </Button>{" "}
          <Button
            onClick={this.handleNoClick}
            className="buttons width-25 btn-decline "
          >
            {this.props.isPermissionPopup ? getMessage("DECLINE") : getMessage("NO")}  
          </Button>
        </>
      );
    }
  };
  render() {
    return (
      <div className="text-center">
        <Modal
          isOpen={this.props.show}
          className={ this.props.isAppEmulation ? "modal-md col-xs-6 col-md-6 col-sm-6 left-2" : "modal-md col-xs-6 col-md-6 col-sm-6 popUp"} 
          zIndex={
            this.props.zIndex
              ? this.props.zIndex
              : isMobile
                ? 1100
                : this.props.isPermissionPopup
                  ? this.props.isAudioVideoPermissionPopUp
                    ? 1052
                    : 1051
                  : !isIE
                    ? 1050
                    : ""
          }
        >
          <ModalHeader className="popupHeader text-center">
            {this.props.message}
            {this.props.warningMessage &&
            <div className="warning">
              {this.props.warningMessage}
            </div>}
          </ModalHeader>
          <ModalFooter className="permissionButtons">
            {this.renderButtons()}
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}
const mapStateToProps = state => {
  return {
    userRole: selectUserRole(state)
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {},
    dispatch
  );
};

export default modalScrollBar(withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(ErrorPopup)));
